import { supabase } from "@/integrations/supabase/client";
import type { CallType } from "./types";

export type CallHistoryStatus = "completed" | "missed" | "declined" | "no_answer" | "ai_answered";

export async function logCallHistory(params: {
  callerId: string;
  receiverId: string;
  conversationId: string;
  callType: CallType;
  status: CallHistoryStatus;
  durationSeconds?: number;
  startedAt?: string;
  endedAt?: string | null;
}) {
  return supabase.from("call_history").insert({
    caller_id: params.callerId,
    receiver_id: params.receiverId,
    conversation_id: params.conversationId,
    call_type: params.callType,
    status: params.status,
    duration_seconds: params.durationSeconds ?? 0,
    started_at: params.startedAt ?? new Date(Date.now() - (params.durationSeconds ?? 0) * 1000).toISOString(),
    ended_at: params.endedAt ?? (params.status === "completed" || params.status === "no_answer" || params.status === "declined" ? new Date().toISOString() : null),
  });
}

export async function deleteCallHistoryEntry(callId: string, userId: string) {
  return supabase
    .from("call_history")
    .delete()
    .eq("id", callId)
    .or(`caller_id.eq.${userId},receiver_id.eq.${userId}`);
}

export async function notifyMissedCall(params: {
  userId: string;
  callerName: string;
  callType: CallType;
  title?: string;
}) {
  return supabase.from("notifications").insert({
    user_id: params.userId,
    title: params.title ?? "Missed Call",
    message: `You missed a ${params.callType} call from ${params.callerName}`,
    type: "missed_call",
  });
}
